import { Component, h } from 'preact';
import { route } from 'preact-router';

/**
 * This handles inquiries URLs without a stage parameter, so the inquiry grid
 * doesn't have to. This means InquiryGridPage's componentDidMount can always
 * rely on having props.stage be set to something.
 */
export class InquiryGridPageIndex extends Component {
  constructor(props) {
    super(props);
    route('/kumita-brokers/inquiries/accepted');
  }

  render() {
    return <div />;
  }
}
